// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React, {useContext, useEffect} from 'react';
import styles from './form.module.less';
import cn from 'classnames';
import {Footer} from './footer';
import {t_methods, t_states} from './types';
import {use_screen} from '../../lib/screen_util';
import {toolip_img_url} from '../toolip_img_url';
import {img_url} from '../img_url';
import {Buttons} from './buttons';
import {open_homepage} from './utils';
import {perr} from 'hola_pub_util';
import Chevron_left from '../../img/hola2023/icons/16/chevron_left.svg';
import {Settings_context} from '../../settings_ctx';

interface i_login_buttons_props {
    on_click: (type:t_methods)=>void;
    go_to: (type:t_states, direction?: number)=>void;
    can_signup: boolean;
    blocks: {
        social?: {[propname: string]: boolean},
    };
    no_banner?: boolean;
    Banner?: JSX.Element;
    full_page: boolean;
    global_back?: boolean;
    img_set?: string;
}

export const State_login_buttons = (props: i_login_buttons_props)=>{
    const {theme} = useContext(Settings_context);
    const {width} = use_screen();
    useEffect(()=>{
        perr({id: 'www_login_view'});
    }, []);
    const logo_fn = ()=>{
      if (props.img_set=='toolip')
        return toolip_img_url('toolip/logo_black.svg');
      return img_url('hola_logo_letters.svg');
    };
    return <div className={styles.login_buttons}>
      <img src={logo_fn()} alt="login"
        className={cn(props.img_set=='toolip' ? styles.login_logo_toolip
          : styles.login_logo, 'lazyload')}
        onClick={()=>{
          if (width < 1024 && props.full_page)
            open_homepage();
        }}/>
      <div className={styles.first_slide_title}>
        {props.global_back && <button className={styles.back_btn}
          onClick={()=>{
            location.href = location.href + '&hide_login=true';
          }}><Chevron_left/></button>}
        {props.img_set=='toolip' ?
          <p className={cn(styles.login_signup_text, theme.med)}>
            Choose a log in method</p> :
          <p className={styles.login_signup_text}>
            <b>Choose a log in method</b></p>}
      </div>
      <Buttons type={'login'} blocks={props.blocks}
        on_click={props.on_click}/>
      {props.can_signup &&
        <p className={cn(theme.p3, styles.login_signup_switch)}>Don't have
          an account? <a className={styles.underline}
            onClick={e=>{
              e.preventDefault();
              props.go_to('signup_buttons');
            }}
            href='#'>Sign up</a></p>}
      <Footer label={'Sign in'} google_terms img_set={props.img_set}/>
    </div>;
};
